export const vehicleTypes = [
  {
    name: 'Легкові автомобілі',
    group: 'CAR',
    external_id: 'B1',
    engines: [
      {
        name: 'до 1600 см3',
        capacity: {
          min: 1,
          max: 1600
        },
        auto_kind_limit: 1600,
        engineVolume: 1600,
        value: 'B1'
      },
      {
        name: '1601-2000 см3',
        capacity: {
          'min': 1601,
          'max': 2000
        },
        auto_kind_limit: 2000,
        engineVolume: 1800,
        value: 'B2'
      },
      {
        name: '2001-3000 см3',
        capacity: {
          'min': 2001,
          'max': 3000
        },
        auto_kind_limit: 3000,
        engineVolume: 2500,
        value: 'B3'
      },
      {
        name: 'більше 3001 см3',
        capacity: {
          'min': 3001,
          'max': 10000
        },
        auto_kind_limit: 3500,
        engineVolume: 3500,
        value:'B4'
      },
    ],
    types: [],
  },
  {
    name: 'Автобус',
    group: 'BUS',
    external_id: 'D1',
    engines: [],
    types: [
      {
        name: 'менше 20 осіб',
        value: 'D1'
      },
      {
        name: 'більше 20 осіб',
        value: 'D2'
      },
    ],
  },
  {
    name: 'Вантажні автомобілі',
    external_id: 'C1',
    group: 'CARGO',
    engines: [],
    types: [
      {
        name: 'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)',
        value: 'C0'
      },
      {
        name: 'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))',
        value: 'C1'
      },
      {
        name: 'С2 (з вантажопідйомністю більше 2т)',
        value: 'C2'
      },
    ],
  },
  {
    name: 'Причіп, Трейлер',
    group: 'TRAILER',
    engine: null,
    external_id: 'E',
    engines: [],
    types: [
      {
        name: 'До вантажного авто',
        value: 'E'
      },
      {
        name: 'До легкового авто',
        value: 'F'
      },
    ],
  },
  {
    name: 'Мотоцикли та моторолери',
    group: 'BIKE',
    external_id: 'A1',
    engines: [
      {
        name: '300 см3 або менше',
        value: 'A1'
      },
      {
        name: 'більше 300 см3',
        value: 'A2'
      },
    ],
    types: [],
  },
  {
    name: 'Легковий електромобіль',
    group: 'CAR',
    external_id: 'B5',
    engine: null,
    engines: [],
    types: [
      {
        name: 'Легковий електромобіль',
        value: 'B5'
      },
    ],
  },
];

export const vehicleGroups = {
  CAR: 'CAR',
  BIKE: 'BIKE',
  BUS: 'BUS',
  CARGO: 'CARGO',
  TRAILER: 'TRAILER',
};

